<div class="relative">
    <!------------------------------------------ Back ------------------------------------>
    <div class="absolute w-[40px] h-[37px] bg-white shadow-lg rounded-full flex justify-center items-center m-2 z-[49]" 
                style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) ;"
                (click)="goback()"
        >
            <img src="icons/Payment/back-payment.png" alt="back" class="w-[30px] h-[30px]" />
    </div>


</div>

<!------------------------------------------ Modal ---------------------------------------->
